import { Environment } from './environment';

export const environment: Environment = {
  baseURL: 'https://prodatex-be-dev.zamia.be',
  daccaBaseURL: 'https://daccaintegration.home-repair.be',
  appInsightsInstrumentationKey: 'fd5e0311-3d58-402e-a7c8-3a9becffccce',
  networkHealthTimeout: 5000,
  maxImageHeight: 600,
  maxImageWidth: 1080,
  imageQuality: 50,
  oktaAuthorizeUrl: 'https://belfius.okta.com/oauth2/aus7fs4k2plZXAGtC417/v1/authorize',
  oktaClientId: '0oa4tjr7dXZ23GYrm416',
  useOkta: true,
  oktaLogoutUrl: 'https://belfius.okta.com/login/signout'
};
